import { render, staticRenderFns } from "./NumberCard.vue?vue&type=template&id=dae5a672&scoped=true"
import script from "./NumberCard.vue?vue&type=script&lang=js"
export * from "./NumberCard.vue?vue&type=script&lang=js"
import style0 from "./NumberCard.vue?vue&type=style&index=0&id=dae5a672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae5a672",
  null
  
)

export default component.exports